import { BreachEvent, click_origin_breach_screen } from '@news-mono/web-common'
import React from 'react'
import { useAuthActions } from '../../../../../user-registration/authentication/AuthenticationProvider'
import { SubscriptionPackages } from '../../../common'
import { createLinkClickEvent } from '../../../createLinkClickHandler'
import BlackFridaySubscriptionPackage from './BlackFridayComponents/BlackFridaySubscriptionPackage'
import {
    StyledBlackFridayBreachContent,
    StyledButton,
    StyledButtonCaption,
    StyledHelpMessage,
    StyledMessage,
    StyledPackage,
    StyledRegistrationInfo,
    StyledTextLink,
    StyledTitle,
} from './BlackFridayBreachContent.styled'

export interface BlackFridayBreachContentProps {
    title: string
    message: React.ReactNode
    cta: string
    subscriptionPackages?: SubscriptionPackages

    breachCreativeName: string
    breachDeal: string
    onEvent: (event: BreachEvent) => void
}

export const BlackFridayBreachContent: React.FC<BlackFridayBreachContentProps> =
    ({
        title,
        message,
        cta,
        subscriptionPackages,
        breachCreativeName,
        breachDeal,
        onEvent,
    }) => {
        const { onSubscribeClick } = useAuthActions()

        return (
            <StyledBlackFridayBreachContent>
                <StyledRegistrationInfo>
                    <StyledTitle>{title}</StyledTitle>
                    <StyledMessage>{message}</StyledMessage>

                    <StyledButton
                        onClick={() => {
                            createLinkClickEvent(
                                breachCreativeName,
                                breachDeal,
                                onEvent,
                            )()
                            onSubscribeClick({
                                callToAction: click_origin_breach_screen,
                            })
                        }}
                    >
                        {cta}
                    </StyledButton>
                    <StyledButtonCaption>
                        Offer only available online.
                    </StyledButtonCaption>
                    <StyledHelpMessage>
                        Need Help?{' '}
                        <StyledTextLink
                            setBlackFridayColorScheme={true}
                            href="tel:1800 811 855"
                        >
                            1800 811 855
                        </StyledTextLink>
                        .
                    </StyledHelpMessage>
                </StyledRegistrationInfo>
                <StyledPackage>
                    {subscriptionPackages &&
                        subscriptionPackages.map(
                            (subscriptionPackageItem, index) => {
                                return (
                                    <BlackFridaySubscriptionPackage
                                        key={index}
                                        breachCreativeName={breachCreativeName}
                                        breachDeal={breachDeal}
                                        onEvent={onEvent}
                                        ribbonTitle={
                                            subscriptionPackageItem.ribbonTitle
                                        }
                                        pretitle={
                                            subscriptionPackageItem.pretitle
                                        }
                                        heading={
                                            subscriptionPackageItem.heading
                                        }
                                        price={subscriptionPackageItem.price}
                                        originalPrice={
                                            subscriptionPackageItem.originalPrice
                                        }
                                        priceQualifier={
                                            subscriptionPackageItem.priceQualifier
                                        }
                                        packagePath={
                                            subscriptionPackageItem.packagePath
                                        }
                                        offerCode={
                                            subscriptionPackageItem.offerCode
                                        }
                                        packageType={
                                            subscriptionPackageItem.packageType
                                        }
                                        cancellationMessage={
                                            subscriptionPackageItem.cancellationMessage
                                        }
                                        googleSKU={
                                            subscriptionPackageItem.googleSKU
                                        }
                                    />
                                )
                            },
                        )}
                </StyledPackage>
            </StyledBlackFridayBreachContent>
        )
    }

BlackFridayBreachContent.displayName = 'BlackFridayBreachContent'

export default BlackFridayBreachContent
